import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { EntityDataDispatcher } from '../entity-data/entity-data.dispatcher';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './item-data.reducer';
import { ItemDataBuilder } from './item-data.builder';
import { ItemDataStore } from './item-data.store';
import { Item } from './item.model';

@Injectable()
export class ItemDataDispatcher extends EntityDataDispatcher<IState, Item> {
  constructor(
    store: Store<any>,
    itemDataStore: ItemDataStore,
    itemDataBuilder: ItemDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      itemDataStore,
      itemDataBuilder,
      globalBannerService,
      translateService
    );
  }
}
